const UPDATE_EXISTING_PROJECT_SPECIAL_NOTE_CONTENTS =
  "UPDATE_EXISTING_PROJECT_SPECIAL_NOTE_CONTENTS";
const EDIT_PROJECT_SPECIAL_NOTE_RESET_DATA =
  "EDIT_PROJECT_SPECIAL_NOTE_RESET_DATA";

export default {
  UPDATE_EXISTING_PROJECT_SPECIAL_NOTE_CONTENTS,
  EDIT_PROJECT_SPECIAL_NOTE_RESET_DATA,
};
